import { Component, EventEmitter, Input, signal } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IFiles, Proofreading } from 'src/app/models/proofreading.model';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';
import { FileService } from 'src/app/services/file.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ProofreadingService } from 'src/app/services/proofreading.service';
import { FileUploadDialog, IFileUploadDialogOptions } from 'src/app/shared/components/dialog/file-upload-dialog/file-upload-dialog.component';
import { FormGroupComponent } from 'src/app/shared/pages/form-group/form-group.component';
import { VIEWMODE } from 'src/app/shared/pages/view/view.component';
import _ from 'lodash';
import { MemberStatus } from 'src/app/models/projects/submodels/members.model';
import { MembersService } from "src/app/services/member.service";
import { ExternStatePayloadFlag } from 'src/app/models/states.model';


@Component({
    selector: "app-proofreading-attachment",
    templateUrl: "./proofreading-attachment.component.html",
    styleUrls: ["./proofreading-attachment.component.scss"]
})
export class ProofreadingAttachmentComponent {

    @Input() proofreading: (Proofreading & { attachements?: { [key: string]: any; }; }) | undefined;
    readonly panelOpenState = signal(false);

    get attachments(): { filename: string, size: number; }[] {
        const relKey = 'R' + this.proofreading?.relecture;
        const files = this.proofreading?.attachements?.[relKey];

        if (Array.isArray(files)) {
            return files
                .map(({ filename, size }) => ({ filename, size }))
                .reverse();
        }

        return [];
    }

    get current_member() {
        return this.s_members.current_member;
    };

    get isApproverInfo(): boolean {
        return this.s_members.isApproverInfo;
    }

    get isApproverDocument(): boolean {
        return this.s_members.isApproverDocument;
    }

    get externState() {
        return this.proofreading?.state;
    }

    get canApprove(): boolean {
        return this.current_member?.status === MemberStatus.PROGRESS
            && (this.isApproverDocument && this.externState?.hasPayloadFlag(ExternStatePayloadFlag.CUSTOMER_CAN_APPROVE)
                || (!this.isApproverDocument && this.isApproverInfo && this.externState?.hasPayloadFlag(ExternStatePayloadFlag.CUSTOMER_INFO_CAN_APPROVE)));
    }


    constructor(
        protected route: ActivatedRoute,
        protected router: Router,
        protected s_loader: LoaderService,
        protected s_auth: AuthService,
        protected s_alert: AlertService,
        protected fb: FormBuilder,
        protected dialog: MatDialog,
        protected translate: TranslateService,
        protected s_file: FileService,
        protected s_proofreading: ProofreadingService,
        protected s_members: MembersService,
    ) {
    }


    openFileModal() {
        const control = new FormControl();
        const config: IFileUploadDialogOptions = {
            title: 'ATTACHMENT',
            text: 'ATTACHMENTS_ADD',
            control,
            multiple: false,
            fileFormats: ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pdf', 'jpg', 'jpeg','png', 'ai', 'dxf', 'ppt', 'pptx', 'eps'],
            maxFileSize: 20000,
            view_mode: VIEWMODE.EDIT,
        };
        this.dialog.open(FileUploadDialog, {
            data: config,
            width: '80rem',
        }).afterClosed().subscribe(async (files) => {
            try {
                if (files && control.value?.length) {
                    const data = {
                        file_attachement: control.value,
                    };
                    await this.s_file.manageFiles(data, [{ key: 'file_attachement' }]);
                    // data.attachements = _.uniqBy([...this.pr?.attachements || [], ...data.attachements], 'filename');                       
                    if (this.proofreading)
                        await this.s_proofreading.patch(this.proofreading?._id, data);

                }
            } catch (err: any) {
                this.s_alert.error(err.message);
            }
        });
    }

    formatSize(size: number): string {
        if (size >= 1024 * 1024) {
            return (size / (1024 * 1024)).toFixed(2) + ' Mo';
        } else if (size >= 1024) {
            return (size / 1024).toFixed(2) + ' Ko';
        } else {
            return size + ' octets';
        }
    }


}
